import React from "react";
import DefaultHead from "../DefaultHead";

const About: React.FC = () => {
  return (
    <div>
      <DefaultHead />
      <p>
        <iframe
          style={{
            border: "none",
            background: "#eee",
            minWidth: "50%",
            maxWidth: "800px",
            height: "80%",
            minHeight: "600px",
            marginTop: "40px",
            padding: "60px",
          }}
          src="https://app.termly.io/policy-viewer/policy.html?policyUUID=ce4fb586-d098-4847-9191-12570601fa68"
        />
      </p>
    </div>
  );
};

export default About;
